import { Attachment, COMMON_ATTACHMENT_FORMATS_MIME_MAP, FileDropperWithAttachments, MuiAlert, Typography } from '@fox/atoms';
import React from 'react';
import { useContentContext } from '../../../content-context';
import { useCustomFieldFileFieldSas } from '../../mutation-hooks/mutation-implementations';
import { CustomFieldEditProps, FileUploadCustomFieldValue } from '../contracts';
import { FieldFlexWrapper } from '../fields';

function convertCustomFieldValueToAttachments(customFieldValue: FileUploadCustomFieldValue): Attachment[] {
	const attachments: Attachment[] =
		customFieldValue?.files?.map(f => {
			return {
				blobUrl: f.url,
				mime: f.mime,
				fileName: f.fileName,
				size: f.size
			};
		}) ?? [];

	return attachments;
}

function convertAttachmentsToCustomFieldValue(attachments: Attachment[]): FileUploadCustomFieldValue {
	const customFieldValue: FileUploadCustomFieldValue = {
		files: attachments?.map(a => {
			return {
				fileName: a.fileName,
				mime: a.mime,
				url: a.blobUrl,
				size: a.size
			};
		})
	};

	return customFieldValue;
}
export const FileUploadCustomField: React.FC<CustomFieldEditProps> = ({ customField, onChange, readonly }) => {
	const { contentId, requestToken } = useContentContext();
	const { error: sasError, loading: sasLoading, mutate: getSasMutation } = useCustomFieldFileFieldSas({ requestToken });

	const attachments = convertCustomFieldValueToAttachments(customField.value as FileUploadCustomFieldValue);

	if (sasError) return <MuiAlert>{sasError}</MuiAlert>;

	return (
		<FieldFlexWrapper>
			{!readonly ? <Typography color="text.disabled">{customField.displayName}</Typography> : null}
			<FileDropperWithAttachments
				disableEditing={sasLoading || readonly}
				getSas={async fileName => {
					const sas = await getSasMutation({ contentId, fileName });
					return sas ?? '';
				}}
				currentAttachments={attachments}
				onAttachCompleted={async attachments => {
					onChange(customField.customFieldId, convertAttachmentsToCustomFieldValue(attachments));
				}}
				allowedMimesMapping={COMMON_ATTACHMENT_FORMATS_MIME_MAP}
				deleteAttachment={async (index: number, _) => {
					const filteredAttachments = attachments?.filter((_, i) => i !== index);
					onChange(customField.customFieldId, convertAttachmentsToCustomFieldValue(filteredAttachments));
				}}
			/>
		</FieldFlexWrapper>
	);
};
